/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type AssociatedMessageNew_lists$ref = any;
type AssociatedMessageNew_messageable$ref = any;
export type AssociatedMessageNewQueryVariables = {|
  messageableId: string
|};
export type AssociatedMessageNewQueryResponse = {|
  +messageable: ?{|
    +$fragmentRefs: AssociatedMessageNew_messageable$ref
  |},
  +lists: ?{|
    +$fragmentRefs: AssociatedMessageNew_lists$ref
  |},
|};
export type AssociatedMessageNewQuery = {|
  variables: AssociatedMessageNewQueryVariables,
  response: AssociatedMessageNewQueryResponse,
|};
*/


/*
query AssociatedMessageNewQuery(
  $messageableId: ID!
) {
  messageable: node(id: $messageableId) {
    __typename
    ...AssociatedMessageNew_messageable
    id
  }
  lists {
    ...AssociatedMessageNew_lists
    id
  }
}

fragment AssociatedMessageNew_lists on Lists {
  id
}

fragment AssociatedMessageNew_messageable on Messageable {
  id
  title
  body
  backgroundImageUrl
  endDate
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "messageableId",
    "type": "ID!"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "messageableId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AssociatedMessageNewQuery",
    "selections": [
      {
        "alias": "messageable",
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "AssociatedMessageNew_messageable"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Lists",
        "kind": "LinkedField",
        "name": "lists",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "AssociatedMessageNew_lists"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AssociatedMessageNewQuery",
    "selections": [
      {
        "alias": "messageable",
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "title",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "body",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "backgroundImageUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "endDate",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Lists",
        "kind": "LinkedField",
        "name": "lists",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "AssociatedMessageNewQuery",
    "operationKind": "query",
    "text": "query AssociatedMessageNewQuery(\n  $messageableId: ID!\n) {\n  messageable: node(id: $messageableId) {\n    __typename\n    ...AssociatedMessageNew_messageable\n    id\n  }\n  lists {\n    ...AssociatedMessageNew_lists\n    id\n  }\n}\n\nfragment AssociatedMessageNew_lists on Lists {\n  id\n}\n\nfragment AssociatedMessageNew_messageable on Messageable {\n  id\n  title\n  body\n  backgroundImageUrl\n  endDate\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '1294a762b9ee61e6bc016569675e5409';

module.exports = node;
